(function () {
'use strict';

/**
 * @file
 * Отправка запроса со счетчиками
 */
var MAX_BATCH_COUNTERS = 42; // определено в Кликдемоне
var COUNTERS_BATCH_TIMEOUT = 15; // интервал в миллисекундах, в течение которого счётчики склеиваются

var countersBatchData = [];
var counterTimerId;

/**
 * Отправка счётчика. Основной транспорт - sendBeacon, запасной - XMLHttpRequest. Быстро поступающие одиночные события
 * накапливаются и отправляются пачками по MAX_BATCH_COUNTERS штук.
 *
 * Количество и порядок параметров соответствует счётчику СЕРПа
 * window.wbt = function(link, path, vars, clck, tree, sts, counterParams)
 *
 * @param {*} link - не используется
 * @param {String} path
 * @param {String} vars
 * @param {*} clck - не используется
 * @param {*} tree - не используется
 * @param {*} sts - не используется
 * @param {Array} counterParams
 */
Ya.Rum.send = function(link, path, vars, clck, tree, sts, counterParams) {
    clearTimeout(counterTimerId);

    var counterSections = getCounterSections(link, path, vars, tree, sts, counterParams);
    // reqid добавляется на случай попадания в батч счётчиков из разных запросов –
    // например, после аякса
    countersBatchData.push('/reqid=' + Ya.Rum.getSetting('reqid') + counterSections.join(''));

    if (countersBatchData.length < MAX_BATCH_COUNTERS) {
        counterTimerId = setTimeout(sendBatchRequest, COUNTERS_BATCH_TIMEOUT);
    } else {
        sendBatchRequest();
    }
};

function sendBatchRequest() {
    var clck = Ya.Rum.getSetting('clck'),
        data = countersBatchData.join('\r\n');

    countersBatchData = [];
    counterTimerId = null;

    if (!clck) {
        return;
    }

    var sendBeaconPostAvailable = navigator.sendBeacon && Ya.Rum.getSetting('beacon'),
        sendBeaconResult = sendBeaconPostAvailable && navigator.sendBeacon(clck, data);

    if (!sendBeaconResult) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', clck);
        xhr.send(data);
    }
}

// Используются только параметры path vars counterParams
function getCounterSections(link, path, vars, tree, sts, counterParams) {
    var slots = Ya.Rum.getSetting('slots');
    return [
        counterParams ? '/' + counterParams.join('/') : '',
        '/path=' + path,
        slots ? '/slots=' + slots.join(';') : '',
        vars ? '/vars=' + vars : '',
        '/cts=' + new Date().getTime(),
        '/*'
    ];
}

}());
